module.exports = __webpack_public_path__ + "img/ics_o_package_failed.40e1de6f.svg";